/**
 * COMPANIES PAGE — Combina BusinessList (lista) + BusinessForm (modale).
 * Pattern analogo a PeoplePage: apre la modale BusinessForm in create
 * o edit a seconda del callback invocato.
 */

import { useState } from 'react';
import BusinessList from '../../entities/business/BusinessList';
import BusinessForm from '../../entities/business/BusinessForm';

type DrawerState =
  | { kind: 'closed' }
  | { kind: 'create' }
  | { kind: 'edit'; businessId: number };

export function CompaniesPage() {
  const [drawer, setDrawer] = useState<DrawerState>({ kind: 'closed' });

  return (
    <>
      <BusinessList
        onCreateClick={() => setDrawer({ kind: 'create' })}
        onEditClick={(businessId) => setDrawer({ kind: 'edit', businessId })}
      />
      {drawer.kind !== 'closed' && (
        <BusinessForm
          businessId={drawer.kind === 'edit' ? drawer.businessId : null}
          onClose={() => setDrawer({ kind: 'closed' })}
        />
      )}
    </>
  );
}
